/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { DateTimePeriod } from './date-time-period';


export interface SearchScansRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    facilityId?: string | null;
    datePeriod?: DateTimePeriod;
}

